import { path } from 'ramda';
import { ERegions } from '../../constants';

// регионы, в которых выбор ЖК из каталога обязателен
// находясь в этих регионах показываем форму-заявку на новый ЖК, пока не выбран ЖК из каталога
export const jkRegions = [
  ERegions.moscow,
  ERegions.moscowRegion,
  ERegions.spb,
  ERegions.spbRegion,
  ERegions.bashkortostan,
  ERegions.nizhniyNovgorodRegion,
  ERegions.rostovRegion,
  ERegions.samaraRegion,
  ERegions.tatarstan,
];

/**
 * TODO: перенести выполнение на бэк и переместить в redux store
 */
export const getJKRegions = (): Array<number> => {
  const offerRegionIds = path<number[]>(['addFormState', 'regionIdsForAnnouncement'], window);

  return Array.isArray(offerRegionIds) && offerRegionIds.length ? offerRegionIds : jkRegions;
};
